
import lifecycle from "page-lifecycle/dist/lifecycle.es5";
const AutoSubmitExam = {
    mounted() {
        window.addEventListener("beforeunload", this.onbeforeunload)
        lifecycle.addEventListener("statechange", this.onPageStateChange)
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.onbeforeunload)
        lifecycle.removeEventListener("statechange", this.onPageStateChange)
    },
    methods: {
        onbeforeunload(e) {
            if (!this.isHaveSubmit) {
                let text = "关闭当前网页，系统将自动交卷，是否确认关闭？"
                e.returnValue = text;
                return text;
            }
        },
        onPageStateChange (event) {
            const state = event.newState
            if (state === "hidden") {
                if (this.examDetail.IsFullScreen === 1) {
                    if (!this.isHaveSubmit) {
                        this.sureSubmit()
                    }
                }
            }
        },
        disabledCopyPaste () {
            const el = this.$refs.examDetail
            el.oncopy = () => false
            el.onpaste = () => false
        }
    },

    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        // 可以访问组件实例 `this`
        if (!this.isHaveSubmit) {
            let text = "关闭当前网页，系统将自动交卷，是否确认关闭？"
            let r = window.confirm(text)
            if (r) {
                this.sureSubmit().finally(() => {
                    next()
                })
            } else {
                next(false)
            }
        } else {
            next()
        }
    }
}

export default AutoSubmitExam
